import React, { useState, useEffect } from "react";
import FirestoreModel from '../firestoreModel';
import {
    ListGroup,
    ListGroupItem,
    Row,
    Col,
    Form,
    FormSelect,
    Button,
    FormGroup,
    FormInput,
    FormFeedback
} from "shards-react";

const AthleteMeetPicker = (props) => {
    let [meetSelected, setMeetSelected] = useState(null);
    let [athleteSelected, setAthleteSelected] = useState(null);
    let [team, setTeam] = useState({});
    let [meets, setMeets] = useState([]);
    let [athleteList, setAthleteList] = useState([]);
    let [accessCode, setAccessCode] = useState('');
    let [filteredAthleteList, setFilteredAthleteList] = useState(null);
    let [initialMeet, setInitialMeet] = useState(null);

    useEffect(() => {
        const fireModel = new FirestoreModel();
        Promise.all([
            fireModel.fetchClubMeetsAsync(props.clubId),
            fireModel.fetchPublicTeamList(props.teamId),
            fireModel.fetchTeamAsync(props.teamId)
        ]).then((values) => {
            setMeets(values[0]);
            setAthleteList(values[1]);
            setTeam(values[2]);

            if (values[2].ParentAccessType && values[2].ParentAccessType !== 2)
                setFilteredAthleteList(values[1]);
            else
                setFilteredAthleteList([]);

            // get next meet
            let nextMeet = values[0].find(meet => new Date(meet.Date) > new Date());
            if (!nextMeet) {
                nextMeet = values[0].sort((a, b) => new Date(b.Date) - new Date(a.Date))[0];
            }
            setMeetSelected(nextMeet);
            setInitialMeet(nextMeet);

            //handleMeetChange({ target: { value: nextMeet.MeetId } });
            props.onMeetChange(nextMeet);
        });


    }, [props.teamId, props.clubId]);

    const handleMeetChange = (event) => {
        console.log("Meet changed: ", event.target.value);
        const selectedMeet = meets.find(meet => meet.MeetId === event.target.value);
        setMeetSelected(selectedMeet);
        if (props.onMeetChange) {
            props.onMeetChange(selectedMeet);
        }
    };

    const handleAthleteChange = (event) => {
        handleAthleteChangeInternal(event.target.value);
    };

    const handleAthleteChangeInternal = (athleteId) => {
        const selectedAthlete = athleteList.find(athlete => athlete.AthleteId === athleteId);
        setAthleteSelected(selectedAthlete);
        if (props.onAthleteChange) {
            props.onAthleteChange(selectedAthlete);
        }
    };

    const handleAccessCodeChange = (event) => {
        const localAccessCode = event.target.value;
        let newData = []
        if (localAccessCode.length >= 4) {
            newData = [...athleteList.filter(athlete => athlete.AthleteId.substring(0, 4) === localAccessCode.substring(0, 4))];



            if (newData.length === 1)
                handleAthleteChangeInternal(newData[0].AthleteId);
            else
                handleAthleteChangeInternal(null);

        }
        else
            handleAthleteChangeInternal(null);

        setFilteredAthleteList(newData);
        setAccessCode(localAccessCode);
    };

    if (team.ParentAccessType === 0 || team.ParentAccessType == null) {
        return (
            <div className="alert alert-danger" role="alert">
                Parent access is not enabled for this team. Please contact your coach or administrator.
            </div>
        );
    }

    if (!meets.length || !athleteList || !filteredAthleteList || !meetSelected) {
        return <div>Loading...</div>;
    }

    //console.log("Next meet: ", nextMeet);
    function parseLocalDate(dateStr) {
        const [year, month, day] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day);
    }

    //disabled={filteredAthleteList === null || filteredAthleteList.length > 0}

    console.log("Rendering meet picker. Meet: ", meetSelected, " Athlete: ", athleteSelected, " Filtered list: ", filteredAthleteList, "Team.ParentAccess:", team.ParentAccessType);

    return (
        <ListGroup flush>
            <ListGroupItem className="p-3">
                <Row>
                    <Col>
                        <Form>
                            <Row form>
                                <Col md="12" className="form-group">
                                    <label>{team.Name}</label>
                                </Col>
                            </Row>
                            <Row form>
                                <Col md="12">
                                    <FormSelect id="meet" onChange={handleMeetChange} defaultValue={meetSelected.MeetId}>

                                        {meets.map(meet => (
                                            <option key={meet.MeetId} value={meet.MeetId}>
                                                {`${parseLocalDate(meet.Date).toLocaleDateString()} ${meet.Name}`}
                                            </option>
                                        ))}
                                    </FormSelect>
                                </Col>
                            </Row>
                            <Row form>
                                <Col md="12">
                                    <FormSelect
                                        id="athlete"
                                        onChange={handleAthleteChange}
                                        disabled={filteredAthleteList === null || filteredAthleteList.length === 1}
                                    >
                                        {filteredAthleteList.map(athlete => (
                                            <option key={athlete.AthleteId} value={athlete.AthleteId}>
                                                {`${athlete.Name}${athlete.AlsoKnownAs ? ` (${athlete.AlsoKnownAs})` : ''}`}
                                            </option>
                                        ))}
                                    </FormSelect>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        {team.ParentAccessType === 2 ?
                                            <><FormInput className="invalid"
                                                required
                                                type="text"
                                                id="feAccessCode"
                                                placeholder="Access Code"
                                                value={accessCode}
                                                onChange={handleAccessCodeChange}
                                                invalid={accessCode.trim().length < 4} /><FormFeedback invalid>Code needs 4 characters.</FormFeedback></> : null}

                                    </FormGroup>

                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </ListGroupItem>
        </ListGroup>
    );
};

export default AthleteMeetPicker;
